<template>
  <layout-main-inner title="订单">
    <div slot="action">
      <create-order-btn />

      <el-dropdown>
        <el-button
          type="info"
          style="margin-left: 10px">
          上传<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="downloadfile">模板下载</el-dropdown-item>
          <el-dropdown-item @click.native="uploadsales">批量上传</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <el-button
        type="info"
        @click="uploadsales">批量上传</el-button> -->
      <a
        ref="downloadfile"
        href="https://sz.songhuang-tea.com/download/中质系统_订单导入模版.xlsx"
        target="_blank"
        rel="noopener noreferrer"></a>
      <upload-new
        ref="uploadNew"
        action="outstock/uploadsales"
        :callback="callback" />
    </div>
    <layout-card-wrap>
      <el-tabs
        v-model="activeTab"
        @tab-click="handleClick">
        <el-tab-pane
          label="全部订单"
          name="1">
          <order-table-all ref="table_1" />
        </el-tab-pane>
        <el-tab-pane
          label="待审单"
          name="2">
          <order-table-audit ref="table_2" />
        </el-tab-pane>
        <el-tab-pane
          label="待发货"
          name="3">
          <order-table
            :key="3"
            ref="table_3"
            :outType="1" />
        </el-tab-pane>
        <!-- <el-tab-pane
          label="刷单"
          name="4">
          <order-table
            :key="4"
            :outType="2" />
        </el-tab-pane>
        <el-tab-pane
          label="特殊"
          name="5">
          <order-table
            :key="5"
            :outType="3" />
        </el-tab-pane> -->
      </el-tabs>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import CreateOrderBtn from './busi/create-order-btn.vue'
import OrderTableAll from './order-table-all.vue'
import OrderTableAudit from './order-table-audit.vue'
import OrderTable from './order-table.vue'

export default {
  name: 'OrderList',
  components: { OrderTableAll, OrderTableAudit, OrderTable, CreateOrderBtn },
  props: {},
  data() {
    return {
      activeTab: '2'
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {
    downloadfile() {
      this.$refs.downloadfile.click()
    },
    uploadsales() {
      this.$refs.uploadNew.upload({ })
    },
    callback() {
      this.$refs['table_' + this.activeTab].fetchList()
    },
    handleClick(e) {
      console.log(e.name)
      this.$refs['table_' + e.name].fetchList()
    }
  }
}
</script>
